module.exports = __webpack_public_path__ + "images/vattenfall52ac2734e1d4caadf372327adfb8e93b.png";